const PRESS_CDN = 'https://neoterra-site.b-cdn.net/press';

export const pressReleaseHeroDesktop = `${PRESS_CDN}/shot%201.png`;
export const pressReleaseHeroMobile = `${PRESS_CDN}/mobile.png`;
export const pressNewsImage = `${PRESS_CDN}/press-news-feature.webp`;
export const cardImage = `${PRESS_CDN}/cardImage.png`;
export const gulfNewsIntegratedCommunitiesImage = `${PRESS_CDN}/ChatGPT%20Image%20Jul%208%2C%202026%2C%2012_30_26%20PM%201.png`;
export const etihadRailImage = `${PRESS_CDN}/rail.png`;
export const khaleejTimesArticleImage = `${PRESS_CDN}/khaleej_times.png`;
export const cbnmeArticleImage = `${PRESS_CDN}/omesh%20sir%20-%20Construction%20bussiness%20news.png`;
export const ibtimesQuoteImage = `${PRESS_CDN}/quote.png`;
export const emiratesProjectsArticleImage = `${PRESS_CDN}/Emirites-omesh%20kumar%20gurnani.png`;
export const logisticsGulfArticleImage = `${PRESS_CDN}/logisticsgulf-omesh%20kumar%20gurnani.png`;
export const eiraCelebrationImage = `${PRESS_CDN}/eira-celebration.jpg`;
export const eiraBuildingImage = `${PRESS_CDN}/eira-building.jpg`;
export const lofficielArabiaEiraImage = `${PRESS_CDN}/lofficiel.jpg`;
